export function error(state = {}, action) {
  switch (action.type) {
    case 'SET_ERROR':
      return { ...state, ...action.error };
    case 'DISCARD_ERROR': {
      return {};
    }
    default:
      return state;
  }
}
